import { render, staticRenderFns } from "./gift-card-brand.vue?vue&type=template&id=10df1542&scoped=true&"
import script from "./gift-card-brand.vue?vue&type=script&lang=js&"
export * from "./gift-card-brand.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-brand.vue?vue&type=style&index=0&id=10df1542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df1542",
  null
  
)

export default component.exports